var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-m-5 md:m-0 h-full flex-1 overflow-hidden"},[_c('tabulator',{attrs:{"columns":_vm.columns,"ajax-path":"unifi/clients","ajax-params":_vm.ajaxParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }